import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { designSystem } from '@yola/ws-ui';
import placeholders from './placeholders';

const { Box, Paragraph } = designSystem;

function getPlaceholderFor(type) {
  const iconMap = {
    code: placeholders.CodeIcon,
    team: placeholders.PersonIcon,
    testimonials: placeholders.PersonIcon,
    menu: placeholders.MenuIcon,
    pricing: placeholders.TicketIcon,
    products: placeholders.TicketIcon,
    services: placeholders.ToolboxIcon,
  };

  return iconMap[type] || placeholders.DefaultIcon;
}

function MediaPlaceholder({ type = null, title = '' }) {
  const IconComponent = getPlaceholderFor(type);
  const iconClasses = classNames('ws-media-placeholder__icon', {
    'ws-media-placeholder__icon--auto': title,
  });

  return (
    <div className="ws-media-placeholder">
      <div className="ws-media-placeholder__box">
        <IconComponent className={iconClasses} />
        {title && (
          <Box marginTop="spacing-2-xs">
            <Paragraph appearance="low-emphasis" isClipped>
              {title}
            </Paragraph>
          </Box>
        )}
      </div>
    </div>
  );
}

MediaPlaceholder.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
};

export default MediaPlaceholder;
